import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubsemnatComponent } from './subsemnat.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [SubsemnatComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [SubsemnatComponent],
})
export class SubsemnatModule {}
